(function () {
  'use strict';

  /* @ngdoc object
   * @name missingPatternsReport
   * @description
   *
   */
  angular
    .module('missingPatternsReport', [
      'ui.router'
    ]);
}());
